export default "__VITE_ASSET__a9371300__"